import type { Shelves } from '../shelves/load';
import { loadLibraryFacts } from './libraryLoad';
import { libraryNeeds } from './library';
import { needsSentence } from '../lib/libraryStates';
import type { MyBooksTab } from './model';

// The attention dots on My books' tabs (Kristi, Oct 31): a small dot before a tab's name while
// something there needs you, gone once it's cleared. Never on the five main sections.
//   Library copies: a library state that needs you (R2: the same parts and words as Shelves' alert line).
//   Owned copies: no dot (filters review, Kristi Nov 2): Not placed yet, Missing an ID and Lent
//     3+ months are worth a look, shown as ringed chips on the tab, and only needs-you lights a tab.
//   Add & import and Update details: no dot (filters review, Kristi Nov 2): No shelf yet and
//     Update details' lists are worth a look, shown as rings; only needs-you lights a tab, so
//     Library copies is My books' only tab with a dot.

export type Attention = Partial<Record<MyBooksTab, string>>;

export async function loadAttention(shelves: Shelves, today: string): Promise<Attention> {
  const out: Attention = {};
  const reading = new Set(shelves.currently_reading.map((b) => b.id));
  const facts = await loadLibraryFacts();
  // The one library sentence (R2, L2, Kristi Nov 2), as Shelves' alert line: "1 loan ended · 2 ready".
  // The tab's tooltip says "Needs you: …". A hold you quieted (Not ready yet) doesn't count.
  const lib = needsSentence(libraryNeeds(facts.loans, reading, today));
  if (lib) out.library = lib;
  return out;
}
